<template>
  <modal
    id="theme-modal"
    :size="'lg'"
    :confirm-text="'Save'"
    confirm-class="btn-primary"
    @confirm="saveTheme"
    :close-text="'Cancel'"
    close-class="btn-default pull-left"
    :isLoading="false"
    :showExit="false"
  >
    <template v-slot:title>Edit Theme</template>

    <template v-slot:body>
      <form>
        <div class="row">
          <div class="col-md-12 mb-15 mt-5">
            <span id="text-color"
              >The default theme is set to be ADA compliant. Any changes in color may result in a
              non ADA compliant experience.</span
            >
            To change the color in the theme select from the options below, or create your own color
            combination.
            <template v-if="!localTheme.isPreset">
              The diagram below is a single page example of where the custom theme changes the
              interface.
            </template>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 mb-15 mt-5">
            <input
              type="radio"
              id="default"
              name="theme"
              class="custom-control-input"
              v-model="localTheme.isPreset"
              :value="1"
            />
            <label class="label-option" for="default">Default Theme</label>
            <div class="mt-15">
              <input
                type="radio"
                id="custom"
                name="theme"
                class="custom-control-input"
                v-model="localTheme.isPreset"
                :value="0"
              />
              <label class="label-option" for="custom">Custom Theme</label>

              <template v-if="!localTheme.isPreset">
                <color-option
                  title="Top Banner"
                  id="top-banner"
                  v-model="localTheme.props[1]"
                  :tooltip="tooltips.builderPage.themeModalBanner"
                />

                <div class="form-group mt-20">
                  <div class="col-sm-5 col-md-12 col-lg-12 custom-title">
                    Logo:
                    <popover
                      :content="tooltips.builderPage.themeModalLogo"
                      v-if="tooltips.builderPage.themeModalLogo"
                    />
                  </div>

                  <div class="col-sm-5 col-lg-12 ml-20 tablet-btn-position">
                    <button
                      class="btn btn-default btn-xs"
                      @click.prevent="$refs.fileInputBtn.click()"
                    >
                      Upload Logo
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-12 ml-20 tablet-padding">
                    <template v-if="!localTheme.props[4]"> <small>No file chosen</small> </template>
                    <template v-else>
                      <span>
                        <small>{{ localTheme.props[4] }}</small>
                      </span>
                      <small>
                        <span class="fas fa-trash-alt" @click="deleteFile"></span>
                      </small>
                    </template>
                    <input
                      class="hidden"
                      ref="fileInputBtn"
                      id="logoPath"
                      @change="handleLogoFile($event)"
                      type="file"
                    />
                  </div>
                </div>

                <color-option
                  title="Onboarding Tracker"
                  id="onboarding-tracker"
                  :tooltip="tooltips.builderPage.themeModalTracker"
                  v-model="localTheme.props[2]"
                />

                <color-option
                  title="Primary Button"
                  id="primary-button"
                  :tooltip="tooltips.builderPage.themeModalBtn"
                  v-model="localTheme.props[3]"
                />
              </template>
            </div>
          </div>
          <div class="col-md-9 mb-15 mt-60">
            <template v-if="!localTheme.isPreset">
              <img
                src="/capsiminbox/images/CapsimInbox_Theme_Legend_Image.png"
                data-testid="themeLegendImg"
                alt="Theme Legend Image"
                width="100%"
                height="100%"
              />
            </template>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import ColorOption from './colorOption';
  import cloneDeep from 'lodash/cloneDeep';
  import { mapActions } from 'vuex';

  export default {
    props: {
      theme: {
        type: Object,
      },
    },
    data() {
      return {
        localTheme: {
          isPreset: this.theme.isPreset,
          props: cloneDeep(this.theme.props),
          logoBuffer: '',
        },
      };
    },

    components: {
      ColorOption,
    },

    methods: {
      ...mapActions(['SET_MILESTONE']),
      ...mapActions('editMode/version', ['updateVersion']),

      handleLogoFile(event) {
        const fileType = event.target.files[0].type;
        const extension = event.target.files[0].name.split('.').pop();
        // Ensure png or jpg extension are lowercase
        const fileName = event.target.files[0].name.replace(extension, extension.toLowerCase());

        if (this.validateImageFile(fileType)) {
          const reader = new FileReader();

          reader.onload = (e) => {
            this.localTheme.logoBuffer = e.target.result.replace(/^data:image\/\w+;base64,/, '');
            this.localTheme.props[4] = fileName.replace(/ /g, '_');
          };

          reader.readAsDataURL(event.target.files[0]);
        }
      },
      deleteFile() {
        this.localTheme.props[4] = '';
        this.localTheme.logoBuffer = '';
      },
      validateImageFile(type) {
        const value = type.split('/')[1];
        if (value === 'png' || value === 'jpeg') return true;
        return false;
      },
      async saveTheme() {
        this.SET_MILESTONE({
          message: 'Adjust a Gadget',
          tooltipDesc: this.tooltips.milestones['9'],
          timeout: 8000,
          milestoneKey: 9,
        });
        await this.updateVersion({
          versionKey: this.$route.params.resourceKey,
          payload: {
            theme: this.localTheme,
          },
        });
        $('#theme-modal').modal('hide');
      },
    },
  };
</script>
<style lang="scss" scoped>
  // bootstrap offset not working, so setting custom position for tablet view
  @media (min-width: 768px) and (max-width: 991px) {
    .tablet-btn-position {
      left: -20px;
    }

    .tablet-padding {
      padding-left: 44%;
    }
  }

  #text-color {
    color: red;
  }

  .fa-trash-alt:hover {
    cursor: pointer;
  }

  .custom-title {
    margin-left: 20px;
    font-weight: bold;
  }

  .label-option {
    font-weight: normal;
  }
</style>
